//
// FileType.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var FileType = {
    REPORT:0,
    DATA:1,
    IMAGE:2,
    XML:3,
    CSS:4,
    REPORTSTATE:5,
    RESOURCE:6
};
export default FileType;
